// 会员管理api
import request from '@/utils/request.js'
import qs from 'qs'

// 会员列表
export const MemberList = (page, phone) => {
  return request({
    method: 'get',
    url: `/zzzx/member/${page}/${phone || ''}`,
  })
}

// 未对接会员列表
export const newMembers = (page, phone) => {
  return request({
    method: 'get',
    url: `/zzzx/newmember/${page}/${phone || ''}`,
  })
}

// 会员详情
export const orderDetails = (id) => {
  return request({
    method: 'get',
    url: `/zzzx/orderdetails/${id}`,
  })
}

// 项目评估列表--查看会员信息
export const getUserInfo = (user_id) => {
  return request({
    method: 'get',
    url: `/zzzx/getuserdetail/${user_id}`,
  })
}
// 会员详情查看订单
export const getorderdelit = (id) => {
  return request({
    method: 'get',
    url: `/zzzx/findoneorderinfo/${id}`,
  })
}

// 添加会员对接记录
export const newUserDockedRecord = (data) => {
  return request({
    method: 'post',
    url: '/zzzx/addrecord',
    data: qs.stringify(data)
  })
}

// 会员添加
export const addMembers = ({
  phone,
  password,
  province,
  mailbox,
  name,
  sex,
  gsmc,
  image,
  area,
  grzw,
  tel
}) => {
  return request({
    method: 'post',
    url: '/zzzx/adduser',
    data: qs.stringify({
      phone,
      password,
      province,
      mailbox,
      name,
      sex,
      gsmc,
      image,
      area,
      grzw,
      tel
    })
  })
}


// 会员删除
export const delsteMember = (user_id) => {
  return request({
    method: 'post',
    url: '/zzzx/deluser',
    data: qs.stringify({
      user_id
    })
  })
}

// 会员修改
export const modifyInfo = ({
  id,
  phone,
  province,
  mailbox,
  name,
  sex,
  gsmc,
  image,
  area,
  grzw,
  tel,
  status,
  level_status,
  level_expired_time
}) => {
  return request({
    method: 'post',
    url: '/zzzx/modifyinfo',
    data: qs.stringify({
      id,
      phone,
      province,
      mailbox,
      name,
      sex,
      gsmc,
      image,
      area,
      grzw,
      tel,
      status,
      level_status,
      level_expired_time
    })
  })
}
